import { render, staticRenderFns } from "./ParcelsSearch.vue?vue&type=template&id=0801b1aa&scoped=true&"
import script from "./ParcelsSearch.vue?vue&type=script&lang=js&"
export * from "./ParcelsSearch.vue?vue&type=script&lang=js&"
import style0 from "./ParcelsSearch.vue?vue&type=style&index=0&id=0801b1aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0801b1aa",
  null
  
)

export default component.exports